import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { convertToTitleCase } from "js/formatting";
import { useMobileHeader } from "hooks/useMobileHeader";
import { useTranslation } from "react-i18next";

import NavLink from "components/General/NavLink";
import AppAlertBanner from "./AppAlertBanner";
import config from "config/config";
import { getImage } from "js/utilities";

export default function UnauthHeader({ logout }) {
  const [currentPage, setCurrentPage] = useState("/");
  const location = useLocation();
  const { open, close } = useMobileHeader();
  const { t } = useTranslation();

  // mobile menu trap focus
  const mobileMenuButton = useRef(null);
  const header = useRef(null);

  useEffect(() => {
    setCurrentPage(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <header
        className="lg:bg-white shadow-drop lg:sticky lg:top-0 lg:z-20"
        ref={header}
      >
        <a className="ui-skip-to-content" href="#mainContent">
          {t("UnAuthCustomerNavbar-skip-content")}
        </a>

        <div id="id_header">
          <div id="id_utilityMenu" className="ui-utilitybar">
            <div className="container py-4">
              <div className="flex flex-row-reverse items-center w-full lg:flex-row">
                <div className="flex">
                  <div id="everlakeLogoHeader">
                    <Link to="/" title="Return to dashboard">
                      <img
                        src={getImage("logo_blue.png")}
                        className="ui-logo-header"
                        alt={`${convertToTitleCase(config.COMPANY_NAME)} Logo`}
                      />
                    </Link>
                  </div>
                </div>

                <div className="hidden lg:flex text-[color:var(--theme-color-portal-title)] font-semibold ml-6 pl-6 border-l border-theme-rule-light">
                  {t("Header-agentTitle")}
                </div>
                <div className="flex items-center justify-start lg:justify-end flex-grow">
                  {/* <button
                  id="id_searchBtn"
                  ref={siteSearchIcon}
                  aria-controls="id_headerSearchForm"
                  aria-expanded={showDesktoSearch ? "true" : "false"}
                  aria-label="Open and focus site search"
                  title="Open and focus site search"
                  className={`ui-btn-icon relative h-7 w-7 rounded-full hidden lg:flex lg:items-center lg:justify-center ${
                    showDesktoSearch ? "ui-active" : ""
                  }`}
                  onClick={() => {
                    setShowDesktopSearch((show) => (show = !show));
                  }}
                >
                  <svg
                    className="ui-icon w-4 h-4 "
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-search"></use>
                  </svg>
                </button> */}
                  {/* <button
                  aria-label="Start chat"
                  title="Start chat"
                  className="ui-btn-icon h-7 w-7 rounded-full hidden mx-2 lg:flex lg:items-center lg:justify-center"
                >
                  <svg
                    className="ui-icon w-4 h-4"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-chat"></use>
                  </svg>
                </button> */}

                  <button
                    id="id_menuBtn"
                    ref={mobileMenuButton}
                    onClick={() => {
                      // header.current.classList.remove("sticky");
                      // header.current.classList.remove("top-0");
                      open();
                    }}
                    aria-label="Main"
                    aria-expanded="false"
                    aria-controls="id_mainMenu"
                    className="ui-btn-icon h-8 w-8 flex items-center justify-center rounded-full m-0 lg:hidden"
                  >
                    <svg
                      className="ui-icon w-5 h-4"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-menu"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="id_mainMenu" className="">
            <div className="ui-navbar w-64 lg:flex lg:w-full lg:z-auto lg:relative">
              <div
                id="id_mobileMenuMask"
                className="hidden fixed inset-0 w-full h-full bg-ui-gray-dark opacity-40 lg:hidden lg:inset-auto lg:z-auto"
              ></div>

              <nav
                aria-label="Main"
                className="ui-main-menu hidden absolute w-64 z-[802] bottom-0 bg-white lg:flex lg:relative lg:w-full lg:z-auto lg:inset-auto lg:bg-transparent lg:container"
              >
                <div className="flex flex-col justify-between h-full">
                  <ul className="ui-disclosure-nav flex flex-col p-0 m-0 left-0 border-t border-ui-gray-medium-light lg:flex-row lg:left-auto lg:border-0 lg:relative">
                    <li>
                      <NavLink
                        mainLink={true}
                        title={t("UnAuthAgentNavbar-navlink-1")}
                        url="/"
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        closeMobileMenu={close}
                      />
                    </li>
                    <li>
                      <NavLink
                        mainLink={true}
                        title={t("UnAuthAgentNavbar-navlink-2")}
                        url="/help"
                        includeUrl="help"
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        closeMobileMenu={close}
                      />
                    </li>
                  </ul>

                  <div className="mt-8 lg:hidden">
                    <ul className="ui-disclosure-nav">
                      {/* <li
                      onKeyDown={(e) => {
                        if (
                          e.key === "Tab" &&
                          localStorage.getItem("isMobileHeaderMenuOpen") &&
                          localStorage.getItem("isMobileHeaderMenuOpen") ===
                            "true"
                        )
                          setTimeout(() => {
                            mobileMenuButton.current.focus();
                          }, 5);
                      }}
                    >
                      <a href="/" className="ui-main-link">
                        <svg
                          className="ui-icon w-4.5 h-4.5  text-ui-blue mr-2"
                          focusable="false"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <use href="#ui-icon-chat"></use>
                        </svg>
                        Live Chat
                      </a>
                    </li> */}
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <AppAlertBanner />
      </header>
    </>
  );
}
